import "../App.css";
import tdCoins from "../images/table_division_coins_roman.png";
import tdExAfter from "../images/table_division_exchange_after_roman_marked.png";
import tdExBefore from "../images/table_division_exchange_before_roman_marked.png";
import tdSolLeft from "../images/table_division_sol_left_roman_marked.png";
import tdSolRight from "../images/table_division_sol_right_roman_marked.png";
import tdTask from "../images/table_division_task_roman_marked.png";
import {
  tutorial5Roman1,
  tutorial5Roman10,
  tutorial5Roman11,
  tutorial5Roman12,
  tutorial5Roman2,
  tutorial5Roman3,
  tutorial5Roman4,
  tutorial5Roman5,
  tutorial5Roman6,
  tutorial5Roman7,
  tutorial5Roman8,
  tutorial5Roman9,
  tutorialButtonNextPage,
  tutorialButtonPreviousPage,
  tutorialButtonStartLevel,
  tutorialTitle
} from "../strings";

function Tutorial5Roman({ finishTutorial, page, handleNext, handlePrevious }) {

  const maxPages = 8; // Note that the first page has index 0. This means maxPages-1 is the last page.

  return (
    <div>
      <div style={{height: "65dvh"}}> {/* Table Division tutorials are the only ones with increased height. */}
        <div className="tutorial-title">
          {tutorialTitle}
        </div>
        <div className="tutorial-body" style={{height: "35dvh"}}>
          {page === 0 && 
            <div>
              {tutorial5Roman1}
              <br></br>&nbsp;<br></br>
              {tutorial5Roman2}
            </div>
          }
          {page === 1 && 
            <div style={{fontSize: "2dvh"}}>
              {tutorial5Roman3}
              <br></br>&nbsp;<br></br>
              <img src={tdCoins} alt="table-division-coins" style={{width: "50dvh"}}/>
              <br></br>&nbsp;<br></br>
              {tutorial5Roman4}
            </div>
          }
          {page === 2 && 
            <div style={{fontSize: "2dvh"}}>
              {tutorial5Roman5}
              <br></br>&nbsp;<br></br>
              <img src={tdTask} alt="table-division-task" style={{width: "45dvh"}}/>
            </div>
          }
          {page === 3 && 
            <div style={{fontSize: "2dvh"}}>
              {tutorial5Roman6}
              <br></br>&nbsp;<br></br>
              <div style={{display: "flex", flexDirection: "row", gap: "2dvh", justifyContent: "center"}}>
                <img src={tdSolLeft} alt="table-division-sol-left" style={{width: "30dvh"}}/>
                <img src={tdSolRight} alt="table-division-sol-right" style={{width: "43dvh"}}/>
              </div>
            </div>
          }
          {page === 4 && 
            <div>
              {tutorial5Roman7}
              <br></br>&nbsp;<br></br>
              {tutorial5Roman8}
            </div>
          }
          {page === 5 && 
            <div style={{fontSize: "2dvh"}}>
              {tutorial5Roman9}
              <br></br>&nbsp;<br></br>
              <div style={{display: "flex", flexDirection: "row", gap: "1dvh", justifyContent: "center"}}>
                <img src={tdExBefore} alt="table-division-ex-before" style={{width: "33dvh"}}/>
                <span style={{display: "flex", alignItems: "center", fontSize: "8dvh"}}>&#10137;</span>
                <img src={tdExAfter} alt="table-division-ex-after" style={{width: "33dvh"}}/>
              </div>
            </div>
          }
          {page === 6 && 
            <div>
              {tutorial5Roman10}
              <br></br>&nbsp;<br></br>
              {tutorial5Roman11}
            </div>
          }
          {page === 7 && 
            <div>
              {tutorial5Roman12}
            </div>
          }
        </div>
      </div>

      {/* Button to start level. */}
      {page === (maxPages-1) && 
        <button
        onClick={finishTutorial}
          className="tutorial-next-button"
        >
        {tutorialButtonStartLevel}
        </button>
      }

      {/* Button to go to previous page. */}
      {page > 0 && 
        <button
          onClick={handlePrevious}
          className="tutorial-previous-button"
        >
        {tutorialButtonPreviousPage}
        </button>
      }

      {/* Button to go to next page. */}
      {page < (maxPages-1) && 
        <button
          onClick={handleNext}
          className="tutorial-next-button"
        >
        {tutorialButtonNextPage}
        </button>
      }
    </div>
  );
}

export default Tutorial5Roman;
